import { cn } from '@/lib/utils';
import type { PlayerDetailData } from '@/hooks/use-coach-data';
import { AttendanceTimeline } from '@/components/shared/attendance-timeline';

interface AttendanceTabProps {
  attendance: PlayerDetailData['attendance'];
  stats: PlayerDetailData['stats'];
}

export function AttendanceTab({ attendance, stats }: AttendanceTabProps) {
  return (
    <div className="space-y-4">
      {/* Stats Overview */}
      <div className="grid grid-cols-4 gap-2">
        <div className="text-center p-2 bg-muted/40 rounded-lg">
          <p className="text-lg font-bold">{stats.attendanceStats.total}</p>
          <p className="text-[10px] text-muted-foreground">Total</p>
        </div>
        <div className="text-center p-2 bg-green-50 dark:bg-green-950/30 rounded-lg">
          <p className="text-lg font-bold text-green-600">{stats.attendanceStats.present}</p>
          <p className="text-[10px] text-muted-foreground">Present</p>
        </div>
        <div className="text-center p-2 bg-yellow-50 dark:bg-yellow-950/30 rounded-lg">
          <p className="text-lg font-bold text-yellow-600">{stats.attendanceStats.late}</p>
          <p className="text-[10px] text-muted-foreground">Late</p>
        </div>
        <div className="text-center p-2 bg-red-50 dark:bg-red-950/30 rounded-lg">
          <p className="text-lg font-bold text-red-600">{stats.attendanceStats.absent}</p>
          <p className="text-[10px] text-muted-foreground">Absent</p>
        </div>
      </div>

      {/* Attendance List */}
      <AttendanceTimeline records={attendance} />
    </div>
  );
}
